import { render, staticRenderFns } from "./footer-foot.vue?vue&type=template&id=43104017&scoped=true&"
import script from "./footer-foot.vue?vue&type=script&lang=js&"
export * from "./footer-foot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43104017",
  null
  
)

export default component.exports